import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { InstitutionProps } from '../../../models/arc-epi-props';
import { GhlPlan } from '../institution-model';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { getCurrentTimeNY } from '../../../../../global/helpers/date-helpers';
import { labelValueStyles } from '../../../../../global/constants/theme/styles/components/label-value-styles';

interface Props {
    settings: InstitutionProps,
    ghlPlan: GhlPlan,
    expandAll: boolean,
    nextYearOffSet?: number,
}

function GhlPlanView(props: Props) {

    const { settings, ghlPlan, expandAll, nextYearOffSet } = props;
    const [expand, setExpand] = useState(false);
    const currentYear = getCurrentTimeNY();
    const tableClasses = labelValueStyles();
    useEffect(() => {
        setExpand(expandAll);
    }, [expandAll]);

    return (
        <Accordion expanded={expand} onChange={() => setExpand(!expand)} >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <p>{ghlPlan?.plan_name}</p>
            </AccordionSummary>
            <AccordionDetails >
                <div className={tableClasses.labelRowContainer}>
                    <LabelAndValue value={ghlPlan?.plan_name} label={settings.planNameLabel} />
                    <LabelAndValue value={ghlPlan?.plan_code} label={settings.planCodeLabel} />
                    <LabelAndValue value={ghlPlan?.billing_account_name} label={settings.billingAccountLabel} />
                    <LabelAndValue value={currentYear?.getFullYear() + nextYearOffSet} label={settings.planYearLabel} />
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

GhlPlanView.defaultProps = {
    nextYearOffSet: 0,
};

export default GhlPlanView;